import { render, staticRenderFns } from "./auth-select-lang.vue?vue&type=template&id=bb2c04f8&"
import script from "./auth-select-lang.vue?vue&type=script&lang=js&"
export * from "./auth-select-lang.vue?vue&type=script&lang=js&"
import style0 from "./auth-select-lang.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports